import { define } from 'wicked-elements'
import Walkway from 'walkway.js'
import bus from '../bus.js'

define('[data-component~="main-logo"]', {
  init () {
    this.walkway = new Walkway({
      selector: '#gallery-weekend-logo',
      duration: '1000'
    })
    this.handleClick = this.handleClick.bind(this)
  },
  connected () {
    this.walkway.draw()
    this.element.classList.add('walkway-init')
    this.element.addEventListener('click', this.handleClick)
  },
  disconnected () {
    this.element.removeEventListener('click', this.handleClick)
  },
  handleClick () {
    window.GWLA_SCROLL['/'] = 0
    bus.emit('map:reset')
  }
})